import providersMatchers from './videosProviders';

function getVideoMatcherFromUrl(url, matcherToReturn) {
  if (matcherToReturn && providersMatchers[matcherToReturn]) {
    return providersMatchers[matcherToReturn];
  }

  return Object.values(providersMatchers).find((currentMatcher) =>
    url.match(currentMatcher.mediaMatch.matcher)
  );
}

export default function getIframeUrl(url = '', platformToMatch) {
  const videoMatcher = getVideoMatcherFromUrl(url, platformToMatch);

  if (!videoMatcher) {
    return '';
  }

  const { mediaMatch } = videoMatcher;
  const match = url.match(mediaMatch.matcher);

  if (!match) {
    return '';
  }

  let iframeUrl = mediaMatch.url;

  match.forEach((value, index) => {
    iframeUrl = iframeUrl.replace(`$${index}`, value || '');
  });

  return iframeUrl;
}
